<template>
    <div :class="label.preview_type + ' previewComponent' ">
        <div id="canvasArea" :class="label.preview_type">
            <div v-bind:class="'pages pages_'+label.uniqueId">
                <div v-bind:class="'label_page_'+label.uniqueId + ' page'+ ' pageUnique_'+this.uuid" v-bind:style="{ width: label.width +'px', height: label.height + 'px' }">
                    <div class="page_blocks_container" v-bind:style="{ width: label.width +'px', height: label.height + 'px' }">
                        <img class="page_image" v-bind:src="label.image"/>
                        <app-previewlines :label="label"></app-previewlines>
                        <app-previewbackgrounds v-show="this.label.backgrounds.length" :label="label"></app-previewbackgrounds>
                        <app-previewforegrounds v-show="this.label.foregrounds.length" :label="label"></app-previewforegrounds>
                        <app-previewcliparts :label="label"></app-previewcliparts>
                    </div>
                    <app-canvas  :label="label" :uuid="this.uuid"></app-canvas>
                    <div class="divSvgSpan">
                        <span class="svgSpan"></span>
                    </div>
                </div>
            </div>
            <div class="svgPreview">
                <div class="svgShadow"></div>
                <div class="startDesign startDesignSvg"><span class="text"> {{this.$store.getters.strings.startDesignSvg}}</span><span class="icon"></span></div>
                <div class="svgWrapper" v-html="label.contentSvg"></div>
            </div>
        </div>
    </div>

</template>
<script>
    import PreviewLines from './Preview/Previewlines';
    import Previewbackgrounds from './Preview/PreviewBackgrounds';
    import Previewforegrounds from './Preview/PreviewForegrounds';
    import PreviewCliparts from './Preview/PreviewCliparts';
    import Canvas from './Canvas/Canvas';

    export default {
        data() {
            return {
                windowSize: $jQuery(window).width(),
                lines: this.label.lines,
                cliparts_blocks: this.label.cliparts_blocks,
                foregrounds: this.label.foregrounds,
                backgrounds: this.label.backgrounds,
                cross : this.$store.state.crosselings.active,
                uuid: '_' + Math.random().toString(36).substr(2, 9)
            }
        },
        props: ['label'],
        components: {
            appPreviewlines: PreviewLines,
            appPreviewbackgrounds: Previewbackgrounds,
            appPreviewforegrounds: Previewforegrounds,
            appPreviewcliparts: PreviewCliparts,
            appCanvas: Canvas
        },
        methods: {
            onResize(event) {
                this.$store.dispatch('initPage', {label: this.label});

            }
        },
        mounted() {
            this.$store.dispatch('initPage', {label: this.label});
            window.addEventListener('resize', this.onResize)
            window.addEventListener('resizeCustom', this.onResize);
        },
        watch: {
            lines: {
                handler: function (after, before) {
                    this.$nextTick(function () {
                        if (typeof (Event) === 'function') {
                            event = new Event('updateCanvas');
                        } else {
                            event = document.createEvent('Event');
                            event.initEvent('updateCanvas', true, true);

                        }
                        window.dispatchEvent(event)
                    });
                },
                deep: true
            },
            cliparts_blocks: {
                handler: function (after, before) {
                    this.$nextTick(function () {
                        if (typeof (Event) === 'function') {
                            event = new Event('updateCanvas');
                        } else {
                            event = document.createEvent('Event');
                            event.initEvent('updateCanvas', true, true);
                        }
                        window.dispatchEvent(event)
                    });
                }, deep: true
            },
            backgrounds: {
                handler: function (after, before) {
                    this.$nextTick(function () {
                        if (typeof (Event) === 'function') {
                            event = new Event('updateCanvas');
                        } else {
                            event = document.createEvent('Event');
                            event.initEvent('updateCanvas', true, true);
                        }
                        window.dispatchEvent(event)
                    });
                },
                deep: true
            },
            foregrounds: {
                handler: function (after, before) {
                    this.$nextTick(function () {
                        if (typeof (Event) === 'function') {
                            event = new Event('updateCanvas');
                        } else {
                            event = document.createEvent('Event');
                            event.initEvent('updateCanvas', true, true);

                        }
                        window.dispatchEvent(event)
                    });
                },
                deep: true
            },
            cross: {
                handler: function (after, before) {
                    this.$nextTick(function () {
                        if (typeof (Event) === 'function') {
                            event = new Event('updateCanvas');
                        } else {
                            event = document.createEvent('Event');
                            event.initEvent('updateCanvas', true, true);

                        }
                        window.dispatchEvent(event)
                    });
                },
                deep: true
            }
        }
    }
</script>
<style>

    .previewComponent {
        width: 100%;
        display: inline-block;
        height: 300px;
    }

    .a-image .previewComponent {
        height: 90px;
    }

    .previewComponent .page_image {
        width: 100%;
        height: auto;
        display: inline-block;
        opacity: 0;
    }

    .previewComponent .page {
        position: absolute;
        display: block;
        z-index: 1;
        display: block;
        z-index: 1;
        height: 100%;
        width: 100%;
        top: 50%;
        left: 50%;
    }

    #canvasArea {
        width: 100%;
        height: 100%;
        position: relative;
    }

    #canvasArea .pages {
        display: block;
        height: 100%;
        width: 90%;
        margin: 0 auto;
        position: relative;
        padding: 0;
        overflow: hidden;
    }

    .textCut {
        color: #8A0F09;
        font-size: 20px;
    }

    .labelsContainer .page-container #canvasArea.svgPreview{
        padding-top: 0px;
    }
    .labelsContainer .page-container .previewComponent.svgPreview{
        height:100%;
     }

    .svgShadow{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        top: 0px;
        box-shadow: inset 0px 0px 4px 1px rgba(0, 0, 0, 0.5);
        border-radius: 0px 10px 0 10px;
        display:none;
    }
    .svgWrapper{
        border-radius: 10px;
        display: none;
    }

    .labelsContainer .page-container .svgPreview .svgPreview .svgWrapper,
    #lightbox-product .svgPreview.previewComponent .svgWrapper,
    .labelsContainer .page-container .svgPreview .svgPreview .svgShadow
    {
        display:block;
    }

    .labelsContainer .page-container .svgPreview.previewContainer.product-images .prev{
        box-shadow: inset 0px 0px 4px 1px rgba(0, 0, 0, 0.5);
        padding: 10px 19px 11px 15px;
        top: -6px;
        left: -7px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Preview.vue